import { OPTION_TYPE } from "./optionType";
export default {
    [OPTION_TYPE.STRING]: "Строка",
    [OPTION_TYPE.INT]: "Число",
    [OPTION_TYPE.BOOL]: "Логический тип (да/нет)",
    [OPTION_TYPE.DATETIME]: "Дата и время",
    [OPTION_TYPE.DICTIONARY]: "Словарь значений",
    [OPTION_TYPE.TAGS]: "Список значений",
    [OPTION_TYPE.IMAGE]: "Изображение",
    [OPTION_TYPE.GEOSPATIAL]: "Геометка",
    [OPTION_TYPE.DECIMAL]: "Десятичное"
};
